import drSeifiImg from "@/assets/dr-seifi-testimonial.png";

const LandingProofStrip = () => {
  return (
    <section className="py-16 md:py-20 bg-secondary">
      <div className="max-w-5xl mx-auto section-padding">
        <p className="text-accent font-semibold text-sm tracking-wide uppercase mb-3 text-center">
          Real Growth Example
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-foreground tracking-tight mb-10 text-center">
          This Is What the Score Is Based On
        </h2>

        <div className="grid md:grid-cols-2 gap-8 items-center">
          {/* Testimonial image */}
          <div className="rounded-2xl overflow-hidden shadow-lg border border-border">
            <img
              src={drSeifiImg}
              alt="Dr. Maryam Seifi – StarBrite Dental testimonial"
              className="w-full h-auto"
              loading="lazy"
            />
          </div>

          {/* Metrics & story */}
          <div>
            <h3 className="text-xl font-bold text-foreground mb-2">StarBrite Dental</h3>
            <p className="text-muted-foreground mb-6 leading-relaxed">
              Dr. Maryam Seifi has partnered with Xpress for over 20 years. Her practice grew more than 10× — from a single-location startup to a multi-million dollar operation — using the same multi-channel system your score is built on.
            </p>

            <div className="grid grid-cols-3 gap-4 mb-6">
              {[
                { metric: "10×", label: "Practice growth" },
                { metric: "20+", label: "Years partnered" },
                { metric: "Multi", label: "Channel system" },
              ].map((s) => (
                <div key={s.label} className="bg-card rounded-xl p-4 border border-border text-center">
                  <p className="text-2xl font-bold text-accent">{s.metric}</p>
                  <p className="text-xs text-muted-foreground mt-1">{s.label}</p>
                </div>
              ))}
            </div>

            <div className="space-y-3">
              {[
                { name: "Dr. Patel", result: "+$62K in new-patient production in one quarter" },
                { name: "Multi-Location DSO", result: "3× new-patient volume in 6 months" },
              ].map((c) => (
                <div key={c.name} className="bg-card rounded-lg p-4 border border-border">
                  <p className="text-xs font-bold tracking-wider uppercase text-muted-foreground mb-1">{c.name}</p>
                  <p className="text-sm font-semibold text-foreground">{c.result}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingProofStrip;
